import gql from 'graphql-tag'

export const FacetFields = gql`
  fragment FacetFields on Facet {
    ... on SimpleFacet {
      facetName
      facetHeader
      options {
        optionName
        displayName
        matchedProductCount
        __typename
      }
      __typename
    }
    ... on RangedFacet {
      facetName
      facetHeader
      options {
        displayName
        from
        to
        matchedProductCount
        __typename
      }
      __typename
    }
    ... on SliderFacet {
      facetName
      facetHeader
      minValue
      maxValue
      __typename
    }
  }
`

export const ProductListFields = gql`
  fragment ProductListFields on Product {
    __typename
    sku
    url
    title
    externalIdentifier
    brand {
      name
      imageUrl
    }
    reviews {
      __typename
      total
      averageScore
    }
    images(limit: $limitImages) {
      __typename
      thumbnail
      largeProduct
      zoom
    }
    inWishlist @include(if: $wishlistEnabled)
    options {
      __typename
      key
      choices {
        __typename
        optionKey
        key
        colour
        title
      }
    }
    variants {
      __typename
      inStock
      inStockLocations @include(if: $clickAndCollectEnabled)
      isCheckStock @include(if: $clickAndCollectEnabled)
      isOrderInStore @include(if: $clickAndCollectEnabled)
      leadTime @include(if: $clickAndCollectEnabled)
      weightGroups @include(if: $clickAndCollectEnabled)
      isBookable @include(if: $clickAndCollectEnabled)
      product {
        __typename
        sku
        url
      }
      vipPrice @include(if: $vipPriceEnabled) {
        displayValue
        amount
      }
      price(currency: $currency, shippingDestination: $shippingDestination) {
        price {
          displayValue
          amount
        }
        rrp {
          displayValue
          amount
        }
      }
      choices {
        __typename
        optionKey
        key
      }
    }
    defaultVariant(
      options: {
        currency: $currency
        shippingDestination: $shippingDestination
      }
    ) {
      vipPrice @include(if: $vipPriceEnabled) {
        displayValue
        amount
      }
      price(currency: $currency, shippingDestination: $shippingDestination) {
        price {
          displayValue
          amount
        }
        rrp {
          displayValue
          amount
        }
      }
      leadTime @include(if: $clickAndCollectEnabled)
      weightGroups @include(if: $clickAndCollectEnabled)
      isBookable @include(if: $clickAndCollectEnabled)
      isCheckStock @include(if: $clickAndCollectEnabled)
      isOrderInStore @include(if: $clickAndCollectEnabled)
      marketedSpecialOffer {
        title {
          content {
            content
            __typename
          }
          __typename
        }
        description {
          content {
            content
            __typename
          }
          __typename
        }
        landingPageLink {
          text
          url
          openExternally
          noFollow
          __typename
        }
        freeGiftProduct {
          sku
          images(limit: 1) {
            largeProduct
            __typename
          }
          title
          price(
            currency: $currency
            shippingDestination: $shippingDestination
          ) {
            rrp {
              displayValue
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      inStock
      inStockLocations @include(if: $clickAndCollectEnabled)
      eligibleForFulfilmentMethods @include(if: $clickAndCollectEnabled)
      __typename
    }
    cheapestVariantPrice(
      currency: $currency
      shippingDestination: $shippingDestination
    ) {
      price {
        displayValue
        amount
      }
      rrp {
        displayValue
        amount
      }
    }
    cheapestVariant(
      currency: $currency
      shippingDestination: $shippingDestination
    ) {
      vipPrice @include(if: $vipPriceEnabled) {
        displayValue
        amount
      }
      price(currency: $currency, shippingDestination: $shippingDestination) {
        price {
          displayValue
          amount
        }
        rrp {
          displayValue
          amount
        }
      }
    }
    mostExpensiveVariant(
      currency: $currency
      shippingDestination: $shippingDestination
    ) {
      vipPrice @include(if: $vipPriceEnabled) {
        displayValue
        amount
      }
      price(currency: $currency, shippingDestination: $shippingDestination) {
        price {
          displayValue
          amount
        }
        rrp {
          displayValue
          amount
        }
      }
    }
    content(keys: $productContentKeys) {
      key
      value {
        ... on ProductContentStringValue {
          stringValue: value
        }
        ... on ProductContentStringListValue {
          stringListValue: value
        }
      }
    }
    marketedSpecialOffer {
      title {
        content {
          content
          __typename
        }
        __typename
      }
      description {
        content {
          content
          __typename
        }
        __typename
      }
      landingPageLink {
        text
        url
        openExternally
        noFollow
        __typename
      }
      freeGiftProduct {
        sku
        images(limit: 1) {
          largeProduct
          __typename
        }
        title
        price(currency: $currency, shippingDestination: $shippingDestination) {
          rrp {
            displayValue
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
`
